// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ForSorting_checkbox__3Ags8","checkedCheckbox":"ForSorting_checkedCheckbox__2fD5x","sortingBox":"ForSorting_sortingBox__G47x8"};